import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import ReactDiffViewer from 'react-diff-viewer-continued';
import moment from 'moment';

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";

//Actions
import {
    generalAuditLogsSearchModulesRequest,
    generalAuditLogsSearchRequest,
    clearRedux,
} from 'Redux/actions';


//Styles
import './index.scss'

const GeneralDetails = () => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { openModal, entityName, entityId, companyId, change, loading, auditlogId, date, changes, action, method, modules, modulesLoading } = useSelector(state => state.generalDetailsRedux);
    const [newChanges, setNewChanges] = useState('');
    const [oldChanges, setOldChanges] = useState('');

    const closeModal = () => {
        setNewChanges('');
        setOldChanges('');
        dispatch(clearRedux("GENERAL_AUDIT_LOGS"));
    }

    useEffect(() => {
        if (openModal) {
            let currentDate = moment().format();
            if (action === 'delete' || action === 'other' || action === 'insert') {
                setOldChanges(JSON.stringify(changes, null, 2))
                setNewChanges(JSON.stringify(changes, null, 2))
            } else {
                let payload = {
                    accountId: companyId || -1,
                    dateRange: {
                        start: "2022-01-01T05:00:00.000Z",
                        end: date || currentDate
                    },
                    action: [
                        "update",
                        "insert",
                        "delete",
                        "other",
                    ],
                    entity: {
                        name: entityName,
                        id: entityId
                    },
                }
                dispatch(generalAuditLogsSearchRequest(payload))
            }
            if (entityName === "Role") {
                dispatch(generalAuditLogsSearchModulesRequest())
            }
        }
    }, [openModal])

    useEffect(() => {
        if ((change && change.items.length) || (change && change.items.length && entityName === "Role" && modules.length)) {
            let { items } = change

            let oldData = null
            let newData = null
            items = items.map((item) => ({ ...item, changes: JSON.parse(item.parameters) }))
            if (method === 'savePreference') {
                let filters = items.find((item) => item.id !== auditlogId && item.changes.preferenceKey == changes.preferenceKey && item.method === method)
                try {
                    setNewChanges(JSON.stringify(changes, null, 2))
                } catch (error) {
                    console.log('error', error)
                }
            } else {
                let filters = items
                if (method && entityName !== 'Manufacturer' && entityName !== 'Role') {
                    filters = items.filter((item) => item?.method === method)
                }

                oldData = filters[1]?.changes || filters[0]?.changes
                newData = filters[0]?.changes

                if (oldData?.permissions && entityName === "Role") {
                    oldData.permissions = oldData.permissions.map((permission) => {
                        let moduleValidate = modules.find((module) => permission.moduleId === module.id)
                        if (moduleValidate) {
                            return {
                                ...permission,
                                moduleName: moduleValidate?.name
                            }
                        } else {
                            return {
                                ...permission
                            }
                        }
                    })
                }

                if (newData?.permissions && entityName === "Role") {
                    newData.permissions = newData.permissions.map((permission) => {
                        let moduleValidate = modules.find((module) => permission.moduleId === module.id)
                        if (moduleValidate) {
                            return {
                                ...permission,
                                moduleName: moduleValidate?.name
                            }
                        } else {
                            return {
                                ...permission
                            }
                        }
                    })
                }
                setOldChanges(JSON.stringify(oldData, null, 2))
                setNewChanges(JSON.stringify(newData, null, 2))
            }
        }
    }, [change, modules])

    return (
        <Modal
            open={openModal}
            title={messages['common_changes']}
            loading={loading || modulesLoading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div className="general-details-container">
                    {
                        newChanges ? <ReactDiffViewer oldValue={oldChanges?.res || oldChanges} newValue={newChanges?.res || newChanges} splitView={false} disableWordDiff={true} showDiffOnly={false} /> : <div className="general-details-message">{messages['activities_tab_no_changes']}</div>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default GeneralDetails;